/* tslint:disable */
/* eslint-disable */
export enum ImportAuctionStartingBidCsvRowConflictType {
  InvalidLotNumber = 'invalid_lot_number',
  InvalidStartingBid = 'invalid_starting_bid',
  LotNumberNotFound = 'lot_number_not_found',
  DuplicateLotNumber = 'duplicate_lot_number'
}
